'use client'
import React, { createContext, useContext, useState, useMemo } from 'react';

const AppContext = createContext(null);

const AppContextProvider = ({ children }) => {
  const [lang, setLang] = useState(1);
  const [loggedIn, setLoggedIn] = useState(false);
  const [factoryId, setFactoryId] = useState(1);
  const [participants, setParticipants] = useState(0)
  const [orderId, setOrderId] = useState("");

  const value = useMemo(() => ({ 
    lang, 
    setLang,
    loggedIn,
    setLoggedIn,
    factoryId, 
    setFactoryId,
    participants,
    setParticipants,
    orderId, 
    setOrderId
  }), [
    lang, 
    setLang,
    loggedIn,
    setLoggedIn,
    factoryId, 
    setFactoryId,
    participants,
    setParticipants,
    orderId, 
    setOrderId
  ]);

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
}

const useAppContext = () => {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error('Trying to access AppContext out of the Provider');
  }

  return context;
};

export { AppContextProvider, useAppContext };

